module.exports = "https://cdn2-fs.clearscore.com/flux/images/7f2c5cce5a7d34e65472378e4dbfa5df.jpg";